import React from 'react';
import { useTheme } from '@/state/ThemeContext';

const Settings: React.FC = () => {
  const { theme, setTheme, toggleTheme } = useTheme();
  return (
  <div className="space-y-6">
    <div>
      <p className="section-title">系統管理</p>
      <h1 className="text-2xl font-semibold text-slate-900">設定</h1>
      <p className="text-sm text-slate-500">
        管理醫院偏好設定、通知與整合。
      </p>
    </div>

    <div className="glass-panel space-y-6 p-6">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">通知路由</h2>
        <p className="text-sm text-slate-500">
          決定哪些團隊會收到關鍵通知。
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {['外科', 'ICU', '櫃檯', '藥局'].map((team) => (
          <label
            key={team}
            className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50/70 px-4 py-3 text-sm font-medium text-slate-700"
          >
            <input type="checkbox" className="rounded border-slate-300 text-brand-blue focus:ring-brand-blue" />
            將通知發送給 {team}
          </label>
        ))}
      </div>
    </div>

    <div className="glass-panel space-y-6 p-6">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">外部整合</h2>
        <p className="text-sm text-slate-500">
          連結團隊仰賴的第三方服務。
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        {['Slack', 'Zendesk', 'PagerDuty'].map((integration) => (
          <div
            key={integration}
            className="rounded-2xl border border-slate-200 bg-white p-4 text-sm text-slate-600"
          >
            <p className="font-semibold text-slate-900">{integration}</p>
            <p className="text-xs text-slate-500">狀態：已連線</p>
            <button className="mt-3 text-xs font-semibold text-brand-blue hover:underline">
              管理
            </button>
          </div>
        ))}
      </div>
    </div>

    <div className="glass-panel space-y-5 p-6">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">外觀主題</h2>
        <p className="text-sm text-slate-500">選擇介面顯示的亮色或深色模式。</p>
      </div>
      <div className="flex flex-wrap items-center gap-4">
        {(['light','dark'] as const).map(mode => (
          <button
            key={mode}
            type="button"
            onClick={() => setTheme(mode)}
            className={`rounded-xl px-4 py-2 text-sm font-semibold min-h-[44px] transition border ${theme===mode ? 'bg-brand-blue text-white border-brand-blue' : 'bg-[var(--color-surface)] text-[var(--color-text-muted)] border-[var(--color-border)] hover:border-brand-blue hover:text-brand-blue'}`}
          >
            {mode === 'light' ? '亮色模式' : '深色模式'}
          </button>
        ))}
        <button
          type="button"
          onClick={toggleTheme}
          className="btn-secondary min-h-[44px]"
        >
          切換目前：{theme === 'light' ? '🌞' : '🌜'}
        </button>
      </div>
    </div>
  </div>
);
};

export default Settings;
